export const getCategoryName = (category: string): string | undefined => {
  const categoryNames: { [key: string]: string } = {
    Акції: 'sale',
    Елементи: 'battery',
    'Готові комплекти': 'assembly',
    'FPV-дрони': 'fpv',
    Електротранспорт: 'transport',
    Іграшки: 'toys',
    Прилади: 'devices',
    'Витратні матеріали': 'materials',
  };

  return categoryNames[category];
};
